import React from 'react';

import { JobApplicantLabel } from './job-applicant-label';

import { AUTOMATED_LABEL_KEYS } from '../util/automated-label-keys';

type InputProps = {
  labels: Array<AutomatedLabel>;
};

export const JobApplicantLabels = (props: InputProps) => {
  const { labels } = props;
  if (!labels) {
    return null;
  }

  // Don't show the relevant license label when there is a required license label on this applicant
  const filteredByOverlappingLabels = labels.filter(
    (label) =>
      !(
        label.automatedLabelKey === AUTOMATED_LABEL_KEYS.HasRelevantLicense &&
        labels.find((val) => val.automatedLabelKey === AUTOMATED_LABEL_KEYS.HasLicense)
      ),
  );

  const filteredByJobLabels = filteredByOverlappingLabels;

  const sortedLabels = filteredByJobLabels.sort((label1, label2) => {
    if (label1.isPositive === null) {
      return 1;
    }
    if (label2.isPositive === null) {
      return -1;
    }
    if (label1.isPositive && label2.isPositive === false) {
      return 1;
    }
    if (label1.isPositive === false && label2.isPositive) {
      return -1;
    }

    return label1.displayName.localeCompare(label2.displayName);
  });

  return (
    <>
      {sortedLabels.map((label) => (
        <JobApplicantLabel label={label} key={label.automatedLabelKey || undefined} />
      ))}
    </>
  );
};
